import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { MailboxIcon } from "lucide-react";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

export function RetractationOption() {
  const t = useCustomText();
  return (
    <Label htmlFor="retractation">
      <Option>
        <OptionIcon>
          <MailboxIcon />
        </OptionIcon>
        <OptionTitle>{t("returnMode.retractation.title")}</OptionTitle>
        <OptionDescription>
          {t("returnMode.retractation.description")}
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="retractation" id="retractation" />
        </OptionAction>
      </Option>
    </Label>
  );
}
